export default "__VITE_ASSET__CpTuGAUl__"